import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Route, Router, Params} from '@angular/router';
import {PayService} from '../shared/services/payService/pay.service';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {Racer} from '../racer-tab/Racer';
import {FormBuilder, Validators} from '@angular/forms';
import {Category} from '../shared/classes/Category';
import {Track} from '../shared/classes/Track';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';
import {TypeOfPayService} from '../shared/services/databaseServices/typeOfPay/type-of-pay.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {VarSymService} from '../shared/services/varSym/var-sym.service';
import {PayInfo} from '../shared/classes/PayInfo';
import {EmailTable} from '../shared/classes/EmailTable';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {EmailService} from '../shared/services/emailService/email.service';

@Component({
  selector: 'app-racer-detail',
  templateUrl: './racer-detail.component.html',
  styleUrls: ['./racer-detail.component.css']
})

export class RacerDetailComponent implements OnInit {

  private static NEW = "new";

  isNew = false;
  plusButton = true;
  editButton = false;
  createTooltip = 'raceDetailPage.startFeeTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.startFeeTab.deleteToolTip';
  addTooltip = 'raceDetailPage.startFeeTab.addToolTip';

  racerForm = this.formBuilder.group({
    name: ['', []],
    surname: ['', []],
    year: ['', []],
    sex: ['', []],
    category: ['', []],
    email: ['', [Validators.email]],
    mobile: ['', []],
    club: ['', []],
    voucher: ['', []],
    note: ['', []],
    gdpr: ['', []],
    timeOfReg: ['', []],
    startFee: ['', []],
    timeOfPay: ['', []],
    paid: ['', []],
    typeOfPay: ['', []],
    vs: ['', []],
    track: ['', []]
  });

  id = undefined;
  racer: Racer = new Racer();
  categories: Category[] = [];
  filteredTrack: Track[] = [];
  sexes = ['Muž', 'Žena'];
  typeOfPay = undefined;
  raceId;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private emailTableService: EmailTableService,
              private racesService: RacesService,
              private emailService: EmailService,
              private formBuilder: FormBuilder,
              private varSymService: VarSymService,
              private typeOfPayService: TypeOfPayService,
              private racerService: RacerService,
              private payService: PayService) {
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.isNew = this.id === RacerDetailComponent.NEW;
    if(this.isNew) {
      this.loadTypeOfPay();
      this.filteredTrack = this.racesService.race.track;
      this.categories = this.racesService.race.categories;
    } else {
      this.racerService.getOneRacer(this.id).then(data => {
        const item = data;
        this.racer = new Racer();
        this.racer.key = this.id;
        this.racer.name = item.data().name;
        this.racer.surname = item.data().surname;
        this.racer.club = item.data().club;
        this.racer.year = item.data().year;
      });
    }
  }

  loadTypeOfPay() {
    this.typeOfPayService.getAll().then(data => {
      this.typeOfPay = BaseDatabaseService.toArray(data);
    });
  }

  save(item) {
  }

  add(item) {
    this.loadFromForm();

    if(this.racer.pay === 'převodem') {
      this.varSymService.getAllVarSym().then(data => {
        const vs = data.data().varSym;
        this.racer.vs = vs;
        this.racer.timeOfReg = new Date();
        this.racer.startNumber = '';
        this.racer.chipNumber = '';
        this.racer.paid = false;
        this.racer.timeOfReg = new Date();
        this.racer.timeOfPay = -1;
        this.racer.track = this.racerForm.getRawValue().track;
        this.varSymService.saveVarSym(vs);
        const obj = Object.assign({}, this.racer);
        this.racerService.createRacer(obj).then(() => {
          this.router.navigate(['/admin/races/allRacers', this.racesService.race.id]);
        });
      })
    } else {
      this.racerService.createRacer(this.racer).then(() => {
        this.router.navigate(['/admin/races/allRacers', this.racesService.race.id]);
      });
    }
  }

  private createMessageDb(payInfo: PayInfo = null, subject){
    this.emailTableService.getOne(this.racesService.race.id).then((data) => {
      const toEmail = this.racer.email;

      const email: EmailTable = data.data().emails.filter(i => i.messageType.toLowerCase() === EmailTable.ON_REG.toLowerCase())[0];

      let message = email.onRegMessage;
      message = message.replace(EmailTable.key_name, this.racer.name);
      message = message.replace(EmailTable.key_surname, this.racer.surname);
      message = message.replace(EmailTable.key_year, this.racer.year);
      message = message.replace(EmailTable.key_club, this.racer.club);
      message = message.replace(EmailTable.key_startFee, this.racer.startFee+'');
      message = message.replace(EmailTable.key_varSym, this.racer.vs);
      message = message.replace(EmailTable.key_account, payInfo.account);
      message = message.replace(EmailTable.key_note, this.racer.note);


      this.emailService.sendEmail(email.onRegFrom , toEmail, email.onRegSubject, message).then(data => {

      });
    });
  }

  private loadFromForm() {
    this.racer.name = this.racerForm.getRawValue().name;
    this.racer.surname = this.racerForm.getRawValue().surname;
    this.racer.year = this.racerForm.getRawValue().year;
    this.racer.sex = this.racerForm.getRawValue().sex;
    this.racer.category = this.racerForm.getRawValue().category;
    this.racer.email = this.racerForm.getRawValue().email;
    this.racer.mobile = this.racerForm.getRawValue().mobile;
    this.racer.club = this.racerForm.getRawValue().club;
    this.racer.voucher = this.racerForm.getRawValue().voucher;
    this.racer.note = this.racerForm.getRawValue().note;
    this.racer.raceId = this.racesService.race.id;
    this.racer.gdpr = true;
    this.racer.startFee = this.racerForm.getRawValue().startFee;
    this.racer.pay = this.racerForm.getRawValue().typeOfPay;

  }

  delete(item) {

  }

}


